import Inputmask from "inputmask";

export class SMSConfirmInput {
    constructor(optionalOptions = {}) {
        this._formSMSConfirm = document.querySelector('.registration-sms-container--form');
        if (!this._formSMSConfirm) {
            this.destructor();
            return true;
        }

        if (!this._formSMSConfirm) {
            this.destructor();
            return true;
        }

        let inputs = this._formSMSConfirm.querySelectorAll('input.registration-form-sms--input')
        if (inputs) {
            for (let i = 0; i < inputs.length; ++i) {
                let input = inputs[i];
                Inputmask({
                    "clearMaskOnLostFocus": true,
                    "clearIncomplete": true,
                    "jitMasking": true,
                    "placeholder": '',
                    "mask": "9"
                }).mask(input);
            }
        }
    }

    destructor() {
        this._formSMSConfirm = null;
    }
}

export default new SMSConfirmInput();
